import React from 'react';
import { Map, User, Lightbulb } from 'lucide-react';
export function BenefitsSection() {
  const scroll = () => document.getElementById('comprar')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section className="bg-[#FDF6E3] py-12 px-4 sm:px-6 lg:px-8" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid md:grid-cols-3 gap-4" data-id="element-3">
          <div className="bg-white p-5 rounded-xl shadow-sm text-center cursor-pointer transform transition hover:scale-105 hover:shadow-lg" onClick={scroll} data-id="element-4">
            <div className="bg-[#1e3a5a] w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-5">
              <Map className="w-6 h-6 text-[#d4a853]" data-id="element-6" />
            </div>
            <h3 className="font-bold text-[#1e3a5a] mb-1 text-sm" data-id="element-7">
              GPS Docente
            </h3>
            <p className="text-xs text-gray-600" data-id="element-8">
              Sabés exactamente a dónde ir clase por clase
            </p>
          </div>
          <div className="bg-white p-5 rounded-xl shadow-sm text-center cursor-pointer transform transition hover:scale-105 hover:shadow-lg" onClick={scroll} data-id="element-9">
            <div className="bg-[#1e3a5a] w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-10">
              <User className="w-6 h-6 text-[#d4a853]" data-id="element-11" />
            </div>
            <h3 className="font-bold text-[#1e3a5a] mb-1 text-sm" data-id="element-12">
              Asistente Invisible
            </h3>
            <p className="text-xs text-gray-600" data-id="element-13">
              Planifica por vos. Vos solo enseñás
            </p>
          </div>
          <div className="bg-white p-5 rounded-xl shadow-sm text-center cursor-pointer transform transition hover:scale-105 hover:shadow-lg" onClick={scroll} data-id="element-14">
            <div className="bg-[#1e3a5a] w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-15">
              <Lightbulb className="w-6 h-6 text-[#d4a853]" data-id="element-16" />
            </div>
            <h3 className="font-bold text-[#1e3a5a] mb-1 text-sm" data-id="element-17">
              Claridad Total
            </h3>
            <p className="text-xs text-gray-600" data-id="element-18">
              De ver poco a ver todo claro
            </p>
          </div>
        </div>
      </div>
    </section>;
}